module.exports = __webpack_public_path__ + "static/mobilenav-back-do-2310d69c836b386e6450d08d94a0a6a4.png";